import { isPlatformBrowser } from '@angular/common';
import {
  ApplicationConfig,
  PLATFORM_ID,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { inject as injectVercelAnalytics } from '@vercel/analytics';

import { routes } from './app.routes';
import { GtmService } from './services/gtm.service';
import { SeoService } from './services/seo.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling({ anchorScrolling: 'enabled' })),
    provideHttpClient(withFetch()),
    provideAppInitializer(() => {
      if (!isPlatformBrowser(inject(PLATFORM_ID))) return;
      const gtm = inject(GtmService);
      try {
        const raw = localStorage.getItem('ds-cookie-consent');
        if (raw) {
          const consent = JSON.parse(raw) as { analytics?: boolean };
          gtm.init(consent.analytics === true);
          return;
        }
      } catch {
        /* ignore corrupt storage */
      }
      gtm.init(false);
    }),
    provideAppInitializer(() => {
      if (!isPlatformBrowser(inject(PLATFORM_ID))) return;
      injectVercelAnalytics();
    }),
    /* Instantiate SeoService so it subscribes to router events + i18n
       and starts updating <title>/<meta> from the first navigation. */
    provideAppInitializer(() => {
      inject(SeoService);
    }),
  ],
};
